// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"7bfb5011","58":"94b0d3ac","144":"0b131e7f","238":"4f793ea6","421":"34a03cc0","453":"cd26325f","455":"aabbf17a","594":"364a6be7","977":"bf7225a8"}[chunkId] + ".chunk.js";
};